import React from 'react'
import ItemTypes from '../../lib/item_types'

const I18n = window.I18n

export default class DatePickerSettings extends React.Component {

  onChange = (e) => {
    const { item, path, handlers } = this.props
    handlers.updateItemAttr(e, item, ItemTypes.ELEMENT.type, path)
  }

  render () {
    const { begin, end, label } = this.props.item

    return (
      <div className="date-picker-settings">
        <div className="form-group">
          <label>{I18n.t('application.titles.label')}</label>
          <input type="text" className="form-control" name="label" value={label || ''} onChange={this.onChange} />
        </div>
      </div>
    )
  }
}
